'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var lodash = require('lodash');
var Tabs = require('@material-ui/core/Tabs');
var Tab = require('@material-ui/core/Tab');
var styles = require('@material-ui/core/styles');
var AppBar = require('@material-ui/core/AppBar');
var Slide = require('@material-ui/core/Slide');
var Box = require('@material-ui/core/Box');
var scrollTrigger = require('@scoir/scroll-trigger');
var Chip = require('@material-ui/core/Chip');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var Tabs__default = /*#__PURE__*/_interopDefaultLegacy(Tabs);
var Tab__default = /*#__PURE__*/_interopDefaultLegacy(Tab);
var AppBar__default = /*#__PURE__*/_interopDefaultLegacy(AppBar);
var Slide__default = /*#__PURE__*/_interopDefaultLegacy(Slide);
var Box__default = /*#__PURE__*/_interopDefaultLegacy(Box);
var Chip__default = /*#__PURE__*/_interopDefaultLegacy(Chip);

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var getDataId = (function (id, idx) {
  return id + "-" + idx;
});

var useUpdateTabData = function useUpdateTabData(id) {
  var _useState = React.useState({}),
    tabData = _useState[0],
    setTabData = _useState[1];
  var updateTabData = React.useCallback(function (idx, value) {
    setTabData(function (prev) {
      var _extends2;
      return _extends({}, prev, (_extends2 = {}, _extends2[getDataId(id, idx)] = value, _extends2));
    });
  }, []);
  return {
    tabData: tabData,
    updateTabData: updateTabData
  };
};

var Context = /*#__PURE__*/React__default["default"].createContext();

var propTypes = {
  id: PropTypes__default["default"].string.isRequired,
  tabs: PropTypes__default["default"].arrayOf(PropTypes__default["default"].oneOfType([PropTypes__default["default"].shape({
    to: PropTypes__default["default"].string.isRequired,
    value: PropTypes__default["default"].string.isRequired,
    label: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].node])
  }), PropTypes__default["default"].func])),
  isButton: PropTypes__default["default"].bool,
  children: PropTypes__default["default"].node,
  selectedIndex: PropTypes__default["default"].number
};

var _excluded$2 = ["id", "items", "children", "onChange"],
  _excluded2 = ["label", "labelText", "className", "value"];
var useStyles$3 = styles.makeStyles({
  tab: {
    '&[aria-selected="true"]:hover, &[aria-selected="true"]:focus': {
      outline: 'none'
    },
    '&:hover, &:focus': {
      outline: 'none',
      textDecoration: 'none'
    }
  }
});

/**
 * CustomTabs is the scoir configuration of MUI Tabs component
 * @param {object} props
 * @prop {string} id
 * @prop {array} items array of objects or fns that return objects, fns will get the relevant tab data passed in set by useSetCustomTabData
 * @prop {node} children
 * @return CustomTabs component
 */
var CustomTabs = function CustomTabs(_ref) {
  var id = _ref.id,
    items = _ref.items;
    _ref.children;
    var _onChange = _ref.onChange,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  var classes = useStyles$3();
  var ctx = React.useContext(Context);
  var tabData = lodash.get(ctx, "tabData");
  var getConf = React.useCallback(function (item, idx, selectedValue) {
    var dataId = getDataId(id, idx);
    var data = lodash.get(tabData, dataId);
    return lodash.isFunction(item) ? item(data, selectedValue) // if an item is a fn, provide it with ctx data for that idx
    : item; // assume item is an object if not a fn
  }, [tabData, id]);
  var defaultValue = React.useMemo(function () {
    return lodash.get(getConf(lodash.head(items), 0), 'value');
  }, [items, getConf]);
  var _useState = React.useState(defaultValue),
    value = _useState[0],
    setValue = _useState[1];
  var selectedValue = lodash.get(rest, 'value', value);
  return /*#__PURE__*/React__default["default"].createElement(Tabs__default["default"], _extends({
    indicatorColor: "primary",
    textColor: "primary",
    variant: "scrollable",
    scrollButtons: "on",
    id: id,
    value: value,
    onChange: function onChange(target, value) {
      setValue(value);
      if (lodash.isFunction(_onChange)) {
        _onChange(value);
      }
    }
  }, rest), lodash.map(items, function (item, idx) {
    var _getConf = getConf(item, idx, selectedValue),
      label = _getConf.label,
      labelText = _getConf.labelText,
      className = _getConf.className,
      value = _getConf.value,
      restOfConf = _objectWithoutPropertiesLoose(_getConf, _excluded2);
    return /*#__PURE__*/React__default["default"].createElement(Tab__default["default"], _extends({
      key: value,
      label: label,
      tabIndex: 0,
      id: "tab-" + label + "-" + idx,
      "aria-label": "Click to view " + (labelText || label),
      "aria-controls": id,
      value: value
    }, restOfConf, {
      className: lodash.reject([className, classes.tab]).join(' ')
    }));
  }));
};
CustomTabs.propTypes = propTypes;

var _excluded$1 = ["children", "id", "container"];

/**
 * CustomTabsProvider Context Wrapped CustomTabs
 * @param {object} props
 * @prop {string} id
 * @prop {array} items array of objects or fns that return objects, fns will get the relevant tab data passed in set by useSetCustomTabData
 * @prop {node} children
 * @return CustomTabsProvider component
 */
var CustomTabsProvider = function CustomTabsProvider(_ref) {
  var children = _ref.children,
    id = _ref.id,
    _ref$container = _ref.container,
    Container = _ref$container === void 0 ? 'div' : _ref$container,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var value = useUpdateTabData(id);
  return /*#__PURE__*/React__default["default"].createElement(Context.Provider, {
    value: value
  }, /*#__PURE__*/React__default["default"].createElement(Container, null, /*#__PURE__*/React__default["default"].createElement(CustomTabs, _extends({
    id: id
  }, rest))), children);
};
CustomTabsProvider.propTypes = _extends({}, propTypes, {
  Container: PropTypes__default["default"].elementType
});

/**
 * useSetCustomTabData
 * this hook returns a fn that can set data for a given item index for the nearest CustomTabsProvider context
 * @param {number} idx this is the index of the item you want to update
 * @return {func} set the data for the relevant idx
 */
var useSetCustomTabData = function useSetCustomTabData(idx) {
  var _useContext = React.useContext(Context),
    updateTabData = _useContext.updateTabData;
  return React.useCallback(function (value) {
    updateTabData(idx, value);
  }, [idx, updateTabData]);
};

var useStyles$2 = styles.makeStyles({
  pageContent: {
    zIndex: 2,
    position: 'relative'
  }
});
var ScrollHideAppBar = function ScrollHideAppBar(_ref) {
  var marginTop = _ref.marginTop,
    appBarProps = _ref.appBarProps,
    slideProps = _ref.slideProps,
    children = _ref.children;
  var classes = useStyles$2();
  var trigger = scrollTrigger.useScrollingUpTrigger();
  return /*#__PURE__*/React__default["default"].createElement(Box__default["default"], {
    overflow: "hidden",
    className: classes.pageContent,
    top: marginTop + "px"
  }, /*#__PURE__*/React__default["default"].createElement(Slide__default["default"], _extends({
    direction: "down",
    "in": trigger
  }, slideProps), /*#__PURE__*/React__default["default"].createElement(AppBar__default["default"], _extends({
    position: "fixed",
    elevation: 0,
    color: "inherit",
    style: {
      top: marginTop + "px"
    }
  }, appBarProps), children)));
};
ScrollHideAppBar.propTypes = {
  marginTop: PropTypes__default["default"].number,
  appBarProps: PropTypes__default["default"].object,
  slideProps: PropTypes__default["default"].object,
  children: PropTypes__default["default"].node
};

var Container = function Container(_ref) {
  var children = _ref.children,
    marginTop = _ref.marginTop,
    appBarProps = _ref.appBarProps,
    slideProps = _ref.slideProps;
  return /*#__PURE__*/React__default["default"].createElement(ScrollHideAppBar, {
    marginTop: marginTop,
    slideProps: slideProps,
    appBarProps: appBarProps
  }, children);
};
Container.propTypes = {
  children: PropTypes__default["default"].node,
  marginTop: PropTypes__default["default"].number,
  appBarProps: PropTypes__default["default"].object,
  slideProps: PropTypes__default["default"].object
};
var getContainer = function getContainer(baseProps) {
  var ContainerHOC = function ContainerHOC(props) {
    return /*#__PURE__*/React__default["default"].createElement(Container, _extends({}, baseProps, props));
  };
  return ContainerHOC;
};

var _excluded = ["tabs", "pathname", "valuesByTo", "children", "marginTop", "appBarProps", "slideProps"];
var useStyles$1 = styles.makeStyles({
  root: {
    minHeight: 0,
    backgroundColor: 'white',
    '& a:hover, & a:focus': {
      outline: 'none',
      textDecoration: 'none'
    }
  }
});
var AppBarTabs = function AppBarTabs(_ref) {
  var tabs = _ref.tabs,
    pathname = _ref.pathname,
    valuesByTo = _ref.valuesByTo,
    children = _ref.children,
    marginTop = _ref.marginTop,
    appBarProps = _ref.appBarProps,
    slideProps = _ref.slideProps,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var classes = useStyles$1();
  var selectedPage = React.useMemo(function () {
    return lodash.get(valuesByTo, pathname, '');
  }, [pathname, valuesByTo]);
  return /*#__PURE__*/React__default["default"].createElement(CustomTabsProvider, _extends({
    component: "nav",
    classes: classes,
    container: getContainer({
      marginTop: marginTop,
      appBarProps: appBarProps,
      slideProps: slideProps
    }),
    items: tabs,
    value: selectedPage
  }, rest), children);
};
AppBarTabs.propTypes = {
  tabs: PropTypes__default["default"].array,
  pathname: PropTypes__default["default"].string,
  appBarProps: PropTypes__default["default"].object,
  valuesByTo: PropTypes__default["default"].object,
  slideProps: PropTypes__default["default"].object,
  children: PropTypes__default["default"].node,
  marginTop: PropTypes__default["default"].number
};

var useStyles = styles.makeStyles(function () {
  return {
    count: {
      backgroundColor: "rgba(0, 125, 170, 0.08)"
    }
  };
});
var formatCount = function formatCount(count) {
  return parseInt(count, 10).toLocaleString('en-US', {
    useGrouping: true
  });
};
var Label = function Label(_ref) {
  var children = _ref.children,
    count = _ref.count,
    icon = _ref.icon;
  var classes = useStyles();
  var formattedCount = React.useMemo(function () {
    return formatCount(count);
  }, [count]);
  return /*#__PURE__*/React__default["default"].createElement(Box__default["default"], {
    px: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, icon, /*#__PURE__*/React__default["default"].createElement(Box__default["default"], {
    mx: 2
  }, children), !count ? null : /*#__PURE__*/React__default["default"].createElement(Chip__default["default"], {
    label: formattedCount,
    size: "small",
    className: classes.count
  }));
};
Label.propTypes = {
  children: PropTypes__default["default"].node,
  count: PropTypes__default["default"].number,
  icon: PropTypes__default["default"].node
};

exports.AppBarTabs = AppBarTabs;
exports.Label = Label;
exports.ScrollHideAppBar = ScrollHideAppBar;
exports["default"] = CustomTabsProvider;
exports.useSetCustomTabData = useSetCustomTabData;
//# sourceMappingURL=index.module.js.map
